import { createSelector } from 'reselect';

import getMinimumOrderInformation, {
  $getMinimumOrderInformation,
} from './getMinimumOrderInformation';

import getOrderingProviderSurchargeInstructions, {
  $getOrderingProviderSurchargeInstructions,
} from './getOrderingProviderSurchargeInstructions';

import getStagedPurchasesTotals, {
  $getStagedPurchasesTotals,
} from './getStagedPurchasesTotals';

// enforcing minimum
import getMinimumSurchargeAmount from './getMinimumSurchargeAmount';
import getOrderMinimumSpendingInclusive from './getOrderMinimumSpendingInclusive';

import getSelectedOffer, { $getSelectedOffer } from './getSelectedOffer';
import calculateTotalsForOrder from '../utils/ordering/calculateTotalsForOrder';
import getRewardsAccrualRate from './getRewardsAccrualRate';
import getStagedPurchases, { $getStagedPurchases } from './getStagedPurchases';
import { getCouponOrderingMethod, getFreeChoiceOrderingMethod } from './config';

const get = (
  minInfo: MinimumOrderInformation | null,
  orderingProviderSurchargeInstructions: SurchargeInstruction[] | null,
  stagedPurchasesTotals: StagedPurchasesTotals,
  minimumSurcharge: number,
  orderMinimumSpendInclusive: boolean,
  selectedOffer: Offer | undefined,
  rewardsAccrualRate: number | undefined,
  purchasedItems: any[],
  couponOrderingMethod: any,
  freeChoiceOrderingMethod: any,
): Surcharge[] => {
  const result: Surcharge[] = [];

  if (minInfo && minInfo.surchargeEnabled) {
    //enforcing minimum

    const amount = minimumSurcharge;
    const minOrderSurcharge = {
      amount,
      description: minInfo.surchargeDescription || 'Minimum Order Surcharge',
      type: minInfo.surchargeType as number,
    };
    if (minOrderSurcharge && minOrderSurcharge.amount) {
      result.push(minOrderSurcharge);
    }
  }

  (orderingProviderSurchargeInstructions || []).forEach(instruction => {
    let discountedMoneyPrice = stagedPurchasesTotals.discountedMoneyPrice;
    if (instruction.isPercentage) {
      discountedMoneyPrice = calculateTotalsForOrder(
        stagedPurchasesTotals,
        selectedOffer,
        undefined,
        rewardsAccrualRate,
        purchasedItems,
        couponOrderingMethod,
        freeChoiceOrderingMethod,
      ).discountedMoneyPrice;
    }

    const surcharge = {
      ...instruction,
      amount: instruction.isPercentage
        ? Math.round(
            ((orderMinimumSpendInclusive
              ? discountedMoneyPrice
              : stagedPurchasesTotals.moneyPrice) *
              instruction.amount) /
              100,
          )
        : instruction.amount,
    };

    if (surcharge.amount) {
      result.push(surcharge);
    }
  });

  return result;
};

export default createSelector(
  [
    getMinimumOrderInformation,
    getOrderingProviderSurchargeInstructions,
    getStagedPurchasesTotals,
    getMinimumSurchargeAmount,
    getOrderMinimumSpendingInclusive,
    getSelectedOffer,
    getRewardsAccrualRate,
    getStagedPurchases,
    getCouponOrderingMethod,
    getFreeChoiceOrderingMethod,
  ],
  get,
);

export const $getOrderingProviderSurcharges = createSelector(
  [
    $getMinimumOrderInformation,
    $getOrderingProviderSurchargeInstructions,
    $getStagedPurchasesTotals,
    getMinimumSurchargeAmount,
    getOrderMinimumSpendingInclusive,
    $getSelectedOffer,
    getRewardsAccrualRate,
    $getStagedPurchases,
    getCouponOrderingMethod,
    getFreeChoiceOrderingMethod,
  ],
  get,
);
